import { render, staticRenderFns } from "./GetAccessToken.vue?vue&type=template&id=28d91a6c&scoped=true&"
import script from "./GetAccessToken.vue?vue&type=script&lang=js&"
export * from "./GetAccessToken.vue?vue&type=script&lang=js&"
import style0 from "./GetAccessToken.vue?vue&type=style&index=0&id=28d91a6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d91a6c",
  null
  
)

export default component.exports